import { NotificationService, CONSTANT, LoaderService, EVENTO, TOOLTIPS, ICONS, ACTIONS, UtilityService } from "../../../../shared/session/index";
import { CustomValidators, RegularExpression, RegularExpressionMessage } from '../../../../shared/validation/customvalidation';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { User } from "../shared/user.model";
import { UserService } from "../shared/user.service";
import { FileuploadComponent } from "src/app/shared/fileupload/fileupload.component";

@Component({
  selector: 'app-user-new',
  templateUrl: 'user-new.component.html',
})

export class UserNewComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild('imagenAnversoComponent') imagenAnversoComponent: FileuploadComponent;
  @ViewChild('imagenReversoComponent') imagenReversoComponent: FileuploadComponent;
  @Input() data: any;
  @Input() titlePage: string;

  formGroupNewUser: FormGroup;
  msgSuccessInsert: string;
  msgErrorInsert: string;
  obligatorioMsg: string;
  user: User;
  maxLengthMsg: string;
  userName: string;
  nomUserMaxLength: number;
  passUserMaxLength: number;
  descripcionMaxLength: number;
  nomUserPatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_MSG;
  onlyNumber: string = RegularExpressionMessage.SOLO_NUMERO_MSG;
  buttonGroup: any;
  DNImaxLength: number;
  nomPathMaxLength: number;
  public typeImage: number;
  estadoPass: number = 0;

  constructor(
    private loaderService: LoaderService,
    private userService: UserService,
    private notificationService: NotificationService,
    public utilityService: UtilityService,
    public fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.user = new User();
    this.msgSuccessInsert = 'Se registró satisfactoriamente';
    this.msgErrorInsert = 'Error al registrar Usuario';
    this.obligatorioMsg = 'Campo Obligatorio';
    this.maxLengthMsg = 'El tamaño máximo es de ';
    this.DNImaxLength = 8;
    this.nomUserMaxLength = 100;
    this.passUserMaxLength = 20;
    this.descripcionMaxLength = 250;
    this.typeImage = CONSTANT.typeImage.edit;
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];
    this.setValuesFormBuilder();
  }

  setValuesFormBuilder() {
    this.formGroupNewUser = this.fb.group({
      userName: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomUserMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE)
      ])],
      userShortName: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomUserMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE)
      ])],
      direccion: ['', Validators.compose([Validators.required])],
      telefono: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomUserMaxLength),
        CustomValidators.pattern(RegularExpression.SOLO_NUMERO)
      ])],
      correo: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomUserMaxLength),
      ])],
      fechaNac: ['', Validators.compose([Validators.required,])],
      DNI: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomUserMaxLength),
        CustomValidators.pattern(RegularExpression.SOLO_NUMERO)])],
      fechaIng: ['', Validators.compose([Validators.required,])],
      Password: ['', Validators.compose([Validators.required,])],
      description: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.descripcionMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE)
      ])],
      seguimiento: [false]
    });
  }

  changeEvent(user: User) {
    this.data = { user: { ID: user.ID, Name: user.UserName } };
    this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
  }

  formGroupNewUserSubmit(event) {
    if (this.formGroupNewUser.invalid)
      return;
    this.user.UserName = event.value.userName;
    this.user.UserShortName = event.value.userShortName;
    this.user.DNI = event.value.DNI;
    this.user.Direccion = event.value.direccion;
    this.user.Telefono = event.value.telefono;
    this.user.Correo = event.value.correo;
    this.user.FechaNac = event.value.fechaNac;
    this.user.FechaIng = event.value.fechaIng;
    this.user.Password = event.value.Password;
    this.user.Description = event.value.description;
    this.user.seguimiento = event.value.seguimiento;

    this.imagenAnversoComponent.insertFile(CONSTANT.imagen.clase.imagen, CONSTANT.imagen.tipo.usuario, "", this.user.DNI.toString());
    this.imagenReversoComponent.insertFile(CONSTANT.imagen.clase.imagen, CONSTANT.imagen.tipo.usuario, "", this.user.DNI.toString());

    (this.imagenAnversoComponent.imageName) ? this.user.FotoRuta = this.imagenAnversoComponent.imageName : this.user.FotoRuta = '';
    (this.imagenReversoComponent.imageName) ? this.user.imagenReverso = this.imagenReversoComponent.imageName : this.user.imagenReverso = '';

    this.user.claseArchivo = CONSTANT.imagen.clase.imagen;
    if (this.user.FotoRuta == "") {
      this.notificationService.error("Debe subir la primera imagen")
      return;
    } else {
      if (this.estadoPass == 0) {
        this.notificationService.error("La contraseña debe tener al menos 6 digitos");
        return;
      } else {
        this.insertarUser(this.user);
      }
    }
  }

  insertarUser(user: User): void {
    this.loaderService.show();
    this.userService.insertarUser(user)
      .subscribe(res => {
        user.ID = res;
        this.notificationService.successful("Se grabo satisfactoriamente");
        this.changeEvent(user);
      },
        error => {
          this.notificationService.error(error.error.message || this.msgErrorInsert);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  onlyDecimalNumberKey(event, value) {
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode == 46 && String(value).indexOf('.') > 0)
      return false;

    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

  validarPass(pass) {
    if (pass.currentTarget.value.length < 6) {
      this.notificationService.warning("La contraseña debe tener al menos 6 digitos");
    } else {
      this.estadoPass = 1;
    }
  }
}
